import React from "react";
import { Select, Typography } from "antd";

const { Paragraph } = Typography;
const { Option } = Select;

export const WidgetsValuesFilterContent = ({
    metadata = [],
    handleFilter,
    selections = {},
}) => {
    return (
        <div>
            {metadata.map((item) => (
                <div className="filters-val">
                    <Paragraph
                        style={{ marginBottom: "4px", color: "#090A09" }}
                    >
                        {item.name}
                    </Paragraph>
                    <Select
                        id={`select-${item.name.replace(/\s+/g, "-")}`}
                        mode="multiple"
                        defaultValue="Austin"
                        style={{ width: "100%" }}
                        rootClassName="custom-select"
                        value={selections[item.name]?.values || []}
                        onChange={(value) => handleFilter(item, value)}
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        maxTagCount={0}
                    >
                        {item?.values?.map((option, i) => (
                            <Option key={i} value={option.value}>
                                {option.value +
                                    (option.count ? ` (${option.count})` : "")}
                            </Option>
                        ))}
                    </Select>
                </div>
            ))}
        </div>
    );
};
